<template>
	<div class="card">
		<div class="card__header">
			<h4 class="card__title">Ранги</h4>
		</div>
		<div class="card__body">
			<div class="rang">
				<div v-for="(rang) in rangs" class="rang__item"
			 		:class="{
						'locked': user && user.rang && user.rang.amount < rang.amount,
						'current': user && user.rang.id === rang.id,
					}">
					<div class="rang__item-bg"></div>
					<div class="rang__item-inner">
						<div class="rang__item-head">
							<h3 class="rang__item-title">{{ rang.title }}</h3>
							<img class="rang__item-icon" :src="rang.icon_url" alt="">
						</div>
						<div class="rang__item-sum">
							<div>
								<h5 class="rang__item-sum-value">
									{{ $root.currency(rang.amount) }}
									<svg class="rang__item-sum-icon" v-if="user && user.rang && user.rang.amount >= rang.amount">
										<use href="#svg-icon-checkmark"></use>
									</svg>
								</h5>
								<div class="text-muted small">сумма депозитов</div>
							</div>
							<div class="text-right"
								 v-if="user && user.rang && user.rang.amount < rang.amount">
								<h5 class="rang__item-sum-value">
									{{ $root.currency(rang.amount - user.payment_amount) }}
								</h5>
								<div class="text-muted small">осталось до ранга</div>
							</div>
						</div>
						<ul class="rang__item-features">
							<li class="rang__item-feature">
								Награда
								<span class="badge badge--primary">{{ $root.currency(rang.reward) }}</span>
							</li>
							<li class="rang__item-feature">
								Кешбек
								<span class="badge badge--primary">{{ rang.cashback_percent }}%</span>
							</li>
							<li class="rang__item-feature">
								Рейкбек
								<span class="badge badge--primary">{{ rang.rakeback_percent }}%</span>
							</li>
							<li class="rang__item-feature">
								Лимит на вывод в сутки
								<span class="badge badge--primary">
									{{ rang.withdraw_limit ? $root.currency(rang.withdraw_limit) : '∞' }}
								</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';

  export default {
      data() {
          return {
              rangs: []
          }
      },
      mounted() {
          this.$root.isLoading = true;

          this.getRangs();
      },
	  computed: {
		  ...mapState(useUserStore, ['user']),
	  },
      methods: {
          getRangs() {
            this.$root.axios.get('/api/info/rangs')
              .then(res => {
                  this.rangs = res.data;
                  
                  this.$root.isLoading = false;
              });  
          }
      }
  }
</script>